import events from '@/constants/events'
import EventBus from '@/EventBus'

/**
 * This emits an event to render the modal. payload contains the information in below format
 * {
        component: InitiativeModal,
        props: {
          show: true
        },
        on: {
          onHide: payload => {
            alert('Modal Hidden')
          }
        }
      }
 * @param payload
 */
export default payload => EventBus.$emit(events.RENDER_MODAL, payload)
